module.exports = __webpack_public_path__ + "img/1026_cover.150a83ae.jpg";